module.exports = __webpack_public_path__ + "static/media/tv.e96bd701.svg";